import { render, staticRenderFns } from "./soldItems-list.vue?vue&type=template&id=bb7be4ea"
import script from "./soldItems-list.vue?vue&type=script&lang=js"
export * from "./soldItems-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports